import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FuseConfigService } from '../../../core/services/config.service';
import { UserService } from '../../../core/services/users.service';
import { PictureModalComponent } from '../../../main/pages/pictures-modal/picture-modal';
import { ToastrService } from 'ngx-toastr';
import ImageCompressor from 'image-compressor.js';
import { FuseDeleteDialogComponent } from '../delete-dialog/delete-dialog.component';
import { EventService } from '../../services/event.service';
import { TranslateService } from '@ngx-translate/core';
import imageCompression from 'browser-image-compression';

@Component({
  selector: 'cropper',
  templateUrl: './cropper.html',
  styleUrls: ['./cropper.scss'],
  standalone: false
})

export class NewCropperComponent implements OnInit, OnChanges {

  @Input() avatar;
  @Input() page;
  @Input() defaultRatio;
  @Input() file;
  @Output() sendImg = new EventEmitter();
  @Output() cropperOpened = new EventEmitter();
  id = Date.now().toString(36) + Math.random().toString(36).substr(2);
  imageChangedEvent: any = '';
  hideRatioPages = ['event', 'blog-new', 'picture', 'elearning'];
  public uploadedImg;
  public defaultImage;
  public defaultImageFile;
  public img = '';
  public imgBase64 = '';
  public imageFromCollection = false;
  public imgEvent;
  public openCropper = false;
  public showAvatarImage = true;
  public fileName = '';
  public cropptedFile;
  public showUndo = false;
  public useRatio = false;
  public ratioX = 1;
  public ratioY = 1;
  public zoomScale = 200;
  public hideRatio = false;
  public firstImageLoad = false;
  public lastImage = '';
  public tempImage = '';
  public imageFromUser = '';
  public collectionImage = '';
  public showCropMessage = false;

  constructor(public dialog: MatDialog, private userService: UserService, private fuseConfig: FuseConfigService,
              public toastr: ToastrService, public eventService: EventService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    if (this.avatar) {
      this.img = this.avatar;
      this.lastImage = 'avatar';
      this.imageFromCollection = true;
      if (this.img && this.img.indexOf('data:') === -1) {
        this.eventService.getImageAsBase64(this.eventService.getFileStream(this.img)).subscribe({
          next: (base64String) => {
            this.imgBase64 = base64String;
          },
          error: (error) => {
            console.error('error Base64:', error);
          }
        });
      }
    }
    if (this.page === 'profile') {
      this.imageFromCollection = true;
    }
    if (this.page === 'blog-new') {
      this.ratioX = 16;
      this.ratioY = 9;
    }
    if (this.defaultRatio && this.hideRatioPages.includes(this.page)) {
      this.hideRatio = true;
    }
    if (this.file) {
      this.fileChangeEvent(this.file);
    }
  }

  ngOnChanges(changes) {
    if (this.page === 'profile' || this.page === 'user-detail' || this.page === 'canton-detail' ||
      this.page === 'org-detail' || this.page === 'fr-user-detail' || this.page === 'setting-form' ||
      this.page === 'elearning') {
      if (changes.avatar && changes.avatar.currentValue) {
        this.img = changes.avatar.currentValue;
        // this.imageLoaded = true;
        // this.deleteButton = true;
      } else {
      }
    }
    if (this.page === 'event' && changes.avatar && changes.avatar.currentValue) {
      this.img = this.avatar;
    }
  }

  fileChangeEvent(event: any): void {
    if (event.target.files[0].size < 10485760) {
      this.imgEvent = event;
      this.defaultImageFile = event;
      if (event.target.files[0].size > 1048576) {
        this.compressImage(event.target.files[0]);
      } else {
        this.loadImage(event.target.files[0]);
      }
    } else {
      let title = this.translate.instant('failure');
      let msg = this.translate.instant('too_big_image');
      this.toastr.error(msg, title);
    }
  }

  loadImage(file) {
    this.uploadedImg = file;
    this.defaultImage = file;
    this.fileName = this.uploadedImg.name;
    if (this.checkFormatOfFile(this.uploadedImg.name)) {
      if (!this.file) {
        this.sendImg.emit(this.uploadedImg);
      }
      const reader = new FileReader();
      const that = this;
      reader.onload = function (e) {
        const res: any = e;
        that.img = res.target.result;
        that.imageFromUser = res.target.result;
      };
      reader.readAsDataURL(this.uploadedImg);
      this.imageFromCollection = false;
      this.showUndo = false;
      if (this.page === 'profile') {
        this.uploadImg();
      }
      if (this.defaultRatio && this.hideRatioPages.includes(this.page)) {
        this.cropImage();
      }
      this.firstImageLoad = true;
      this.tempImage = 'new';
    } else {
      this.toastr.error('Bad file format', 'Error!');
    }
  }

  compressImage(file) {
    let _quality = 0.8;
    if (file.size > 5000000) {
      _quality = 0.4;
    }
    if (file.size < 5000000 && file.size > 2000000) {
      _quality = 0.6;
    }
    if (file.size < 2000000 && file.size > 1000000) {
      _quality = 0.8;
    }
    let that = this;
    new ImageCompressor(file, {
      quality: _quality,
      maxWidth: 800,
      success(result: any) {
        that.loadImage(result);
      },
      error(e) {
        console.log(e.message);
      },
    });
  }

  cropImage() {
    if (this.defaultRatio && this.hideRatioPages.includes(this.page)) {
      this.useRatio = true;
      this.setRatio(16, 10);
    }
    this.openCropper = true;
    this.cropperOpened.emit(true);
    this.imageChangedEvent = this.defaultImageFile;
    this.showAvatarImage = false;
    this.showUndo = false;
    this.showCropMessage = true;
    setTimeout(() => {
      this.showCropMessage = false;
    }, 5000);
  }

  imageCroppedInFile(imageFile) {
    this.cropptedFile = imageFile;
  }

  imageLoaded() {
    // show cropper
  }

  loadImageFailed() {
    // show message
  }

  deleteImage() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent, {
      panelClass: 'unsave-form-dialog',
      width: '300px',
      data: {title: 'Delete', message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.img = '';
        this.sendImg.emit('');
        this.lastImage = '';
        this.tempImage = '';
      }
    });
  }

  choosePicture() {
    let dialogRef = this.dialog.open(PictureModalComponent, {
      panelClass: 'picture-form-dialog',
      width: '70vw',
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.img = res.src;
        this.collectionImage = res.src;
        this.imageFromCollection = true;
        this.showUndo = false;
        this.sendImg.emit({imgType: 'url', img: this.img});
        setTimeout(() => {
          if (this.img && this.img.indexOf('data:') === -1) {
            this.eventService.getImageAsBase64(this.eventService.getFileStream(this.img)).subscribe({
              next: (base64String) => {
                this.imgBase64 = base64String;
                this.tempImage = 'collection';
                console.log(this.img);
                if (this.defaultRatio && this.hideRatioPages.includes(this.page)) {
                  this.cropImage();
                }
              },
              error: (error) => {
                console.error('error Base64:', error);
              }
            });
          }
        }, 100);
      }
    });
  }

  checkFormatOfFile(name) {
    const exts = ['.png', '.gif', '.jpeg', '.jpg'];
    return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(name.toLowerCase());
  }

  saveAvatar() {
    this.lastImage = this.tempImage;
    if (!this.fileName && this.img) {
      this.fileName = this.img;
    }
    const _uploadedImg: any = this.cropptedFile;
    _uploadedImg.lastModifiedDate = new Date();
    _uploadedImg.name = this.fileName;
    this.uploadedImg = _uploadedImg;
    this.blobToFile(this.uploadedImg.blob, this.fileName).then(result => {
      this.sendImg.emit(result);
    });
    this.imgEvent = {
      target: {
        files: [this.uploadedImg]
      }
    };
    if (this.page === 'profile') {
      this.blobToFile(this.uploadedImg.blob, this.fileName).then(result => {
        this.uploadedImg = result;
        this.uploadImg();
      });
    }

    const reader = new FileReader();
    const that = this;
    reader.onload = function (e) {
      const res: any = e;
      that.img = res.target.result;
      if (that.lastImage === 'collection') {
        that.collectionImage = res.target.result;
      }
      if (that.lastImage === 'new') {
        that.imageFromUser = res.target.result;
      }
    };
    reader.readAsDataURL(_uploadedImg.blob);

    this.showAvatarImage = true;
    this.openCropper = false;
    this.cropperOpened.emit(false);
    if (this.defaultRatio) {
      this.showUndo = false;
    } else {
      this.showUndo = true;
    }
    this.useRatio = false;
    if (this.page === 'blog-new') {
      this.ratioX = 16;
      this.ratioY = 9;
    } else {
      this.ratioX = 1;
      this.ratioY = 1;
    }
    this.firstImageLoad = false;
  }


  uploadImg() {
    this.userService.changeLogo(this.uploadedImg).subscribe((response: any) => {
      localStorage.setItem('logo', response.logo);
      this.fuseConfig.setLogo(localStorage.getItem('logo'));
      this.img = response.logo;
      this.showAvatarImage = true;
    });
  }

  undoImage() {
    this.uploadedImg = this.defaultImage;
    this.imgEvent = {
      target: {
        files: [this.uploadedImg]
      }
    };
    const reader = new FileReader();
    const that = this;
    reader.onload = function (e) {
      const res: any = e;
      that.img = res.target.result;
    };
    reader.readAsDataURL(this.uploadedImg);
    this.showUndo = false;
    if (this.page === 'profile') {
      this.uploadImg();
    }
  }

  cancelAvatar() {
    this.showAvatarImage = true;
    this.openCropper = false;
    this.cropperOpened.emit(false);
  }

  removeNewImg() {
    this.cancelAvatar();
    this.img = '';
    setTimeout(() => {
      if (this.lastImage === 'avatar' || this.lastImage === 'collection') {
        this.img = this.lastImage === 'avatar' ? this.avatar : this.collectionImage;
        this.imageChangedEvent = '';
        this.imageFromCollection = true;
        if (this.img && this.img.indexOf('data:') === -1) {
          this.eventService.getImageAsBase64(this.eventService.getFileStream(this.img)).subscribe({
            next: (base64String) => {
              this.imgBase64 = base64String;
            },
            error: (error) => {
              console.error('error Base64:', error);
            }
          });
        }
      }
      if (this.lastImage === 'new') {
        this.img = this.imageFromUser;
      }
      if (!this.lastImage) {
        this.imgBase64 = '';
        this.imgEvent = '';
        this.tempImage = '';
        this.sendImg.emit('');
      }
      this.firstImageLoad = false;
    });
  }

  setRatio(x, y) {
    this.ratioX = x;
    this.ratioY = y;
  }

  chooseRatio(e) {
    this.useRatio = e;
  }

  setScale(e) {
    // if (e && +this.zoomScale <= 400) {
    //   this.zoomScale = +this.zoomScale + 100;
    // } else if (!e && +this.zoomScale >= 300) {
    //   this.zoomScale = +this.zoomScale - 100;
    // }
  }

  getImage(name) {
    if (!name) {
      return;
    }
    if (name && name.indexOf('data:') !== -1) {
      return name;
    }
    return this.eventService.getFileStream(name);
  }

  async blobToFile(theBlob, fileName) {
    return imageCompression(theBlob, {
      alwaysKeepResolution: true,
      maxSizeMB: 1,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    }).then(compressedFile => {
      return  new File([compressedFile], fileName, {lastModified: new Date().getTime(), type: theBlob.type});
    });
  }
}
